import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './components/Routes';
import { AuthProvider } from './context/AuthContext';
import Nav from './components/nav/Nav';

function App() {
  return (
      <AuthProvider>
        <Nav/>
        <Router />
      </AuthProvider>
  );
}

export default App;